export class Graph {
    constructor(
        public xaxis?: string,
        public xaxis2?: string,
        public yaxis?: string,
        public yaxis2?: string
        ) { }
}